import { ReactNode } from 'react';

import {
  Box,
  DialogContent,
  DialogTitle,
  IconButton,
  Popover,
} from '@mui/material';

import FontAwesomeIcon from '../FontAwesomeIcon';
import { classNames } from '../utils';

import styles from './StlPopup.module.css';

interface StlPopoverProps {
  anchorEl: HTMLElement;
  isOpen: boolean;
  onClose: () => void;
  title?: ReactNode;
  children?: ReactNode;
  showCloseBtn?: boolean;
  classes?: string[];
}
/**
 * Unlike StlPopup, StlPopover is positioned relative to the parent component using `anchorEl`,
 * while StlPopup has a dimmed backdrop and it is centered within the window.
 */
export function StlPopover({
  isOpen,
  onClose,
  title,
  children,
  showCloseBtn = true,
  anchorEl,
  classes = [],
}: StlPopoverProps) {
  return (
    <Popover
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      className={classNames(styles.custom_dialog, ...classes)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          className: styles.dialog_paper,
        },
      }}
    >
      <Box display="flex" className={styles.dialog_title_wrapper}>
        <DialogTitle className={styles.dialog_title}>{title}</DialogTitle>
        {showCloseBtn && (
          <IconButton
            onClick={onClose}
            size="small"
            className={styles.closeBtn}
          >
            <FontAwesomeIcon name="xmark" type="sharp-solid" size="0.875rem" />
          </IconButton>
        )}
      </Box>
      {children && (
        <DialogContent className={styles.dialog_content}>
          {children}
        </DialogContent>
      )}
    </Popover>
  );
}
